import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { useSnackbar } from "react-simple-snackbar";
import { addUpdateConsultant } from "../api/consultants-api";
import { getLcaMasterByUuid, saveLcaMaster, updateLcaMaster, deleteLcaMaster } from "../api/lca-master-api";
import { Md5 } from "ts-md5";
import { useNavigate } from "react-router-dom";

import DatePicker from "react-datepicker";
import moment from "moment";

export default function EmployeeDetailsForm(props: { profile: any }) {
    const { register, handleSubmit, reset } = useForm();
    const [openSnackbar, closeSnackbar] = useSnackbar();
    const format2 = "YYYY-MM-DD";
    const navigate = useNavigate();
    const [lcaRecords, setLcaRecords] = useState<any[]>([]);
    const [newLcaDateObj, setNewLcaDateObj] = useState<any>(null);
    const [newLcaLocation1, setNewLcaLocation1] = useState("");
    const [newLcaLocation2, setNewLcaLocation2] = useState("");
    const [newLcaLocation3, setNewLcaLocation3] = useState("");
    const [newLcaRate1, setNewLcaRate1] = useState("");
    const [newLcaRate2, setNewLcaRate2] = useState("");
    const [newLcaRate3, setNewLcaRate3] = useState("");

    useEffect(() => {
        if (props.profile?.uuid) {
            loadLcaMaster();
        }
    }, [props.profile?.uuid]);

    const loadLcaMaster = async () => {
        if (props.profile?.uuid) {
            const records = await getLcaMasterByUuid(props.profile.uuid);
            setLcaRecords(records || []);
        }
    };

    const handleAddLca = async () => {
        if (!newLcaDateObj || (!newLcaRate1 && !newLcaRate2 && !newLcaRate3) || !props.profile?.uuid) {
            openSnackbar("Please enter effective date and at least one rate");
            return;
        }
        const data = {
            uuid: props.profile.uuid,
            effective_dt: moment(newLcaDateObj).format(format2),
            location_1: newLcaLocation1,
            location_2: newLcaLocation2,
            location_3: newLcaLocation3,
            lca_rate_1: newLcaRate1,
            lca_rate_2: newLcaRate2,
            lca_rate_3: newLcaRate3,
        };
        const result = await saveLcaMaster(data);
        if (result?.error) {
            openSnackbar("Error saving LCA rate");
        } else {
            openSnackbar("LCA rate saved successfully");
            setNewLcaDateObj(null);
            setNewLcaLocation1("");
            setNewLcaLocation2("");
            setNewLcaLocation3("");
            setNewLcaRate1("");
            setNewLcaRate2("");
            setNewLcaRate3("");
            loadLcaMaster();
        }
    };

    const handleDeleteLca = async (id: number) => {
        const result = await deleteLcaMaster(id);
        if (result?.error) {
            openSnackbar("Error deleting LCA rate");
        } else {
            openSnackbar("LCA rate deleted");
            loadLcaMaster();
        }
    };

    if (props.profile.dob) {
        props.profile.dob = moment.utc(props.profile.dob.toLocaleString()).format("YYYY-MM-DD");
    }

    if (props.profile.date_of_joining) {
        props.profile.date_of_joining = moment.utc(props.profile.date_of_joining.toLocaleString()).format("YYYY-MM-DD");
    }

    if (props.profile.date_of_exit) {
        props.profile.date_of_exit = moment.utc(props.profile.date_of_exit.toLocaleString()).format("YYYY-MM-DD");
    }

    useEffect(() => {
        // you can do async server request and fill up form
        console.log(props.profile);
        reset(props.profile);
    }, [reset]);

    const onSubmit: SubmitHandler<any> = async (data: any) => {
        if (props.profile?.uuid) {
            const consultantData = {
                // ...props.profile,

                uuid: props.profile.uuid,
                active: props.profile.active,
                bgv: props.profile.bgv,
                dob: moment(data?.dob).format(format2),
                email: data.email,
                masked_ssn: data.masked_ssn,

                name: data.name,
                phone: data.phone,

                status: props.profile.status,
                bgv_by: props.profile.bgv_by,
                bgv_dt: props.profile.bgv_dt,

                street: data.street,
                city: data.city,
                district: data.district,
                state: data.state,
                zip: data.zip,
                country: data.country,

                date_of_joining: data.date_of_joining || null,
                date_of_exit: data.date_of_exit || null,

                designation: data.designation,


                // FIXME
                // client: props.profile.client,
                unstructured: props.profile.unstructured,
                fixed_payroll: props.profile.fixed_payroll,
                entity: props.profile.entity || "MTINC",
                payroll_process: props.profile.payroll_process,
            };

            // Explicitly remove project_uuid
            // delete consultantData.project_uuid;
            // delete consultantData.project_master_pid;

            addUpdateConsultant(consultantData)
                .then((result: any) => {
                    console.log(result);
                    openSnackbar(result?.error ? "Unable to save Consultant" : "Consultant Saved.");
                })
                .catch((error: any) => {
                    openSnackbar("Unable to save Consultant");
                });
        } else {
            const consultantData: any = {
                uuid: Md5.hashStr(data.email),
                active: data?.active,
                bgv: data?.bgv,
                dob: data?.dob,
                email: data?.email,

                masked_ssn: data?.masked_ssn,

                name: data?.name,
                phone: data?.phone,

                status: data?.status,

                bgv_by: data?.bgv_by,
                bgv_dt: data?.bgv_dt,

                street: data.street,
                city: data.city,
                district: data.district,
                state: data.state,
                zip: data.zip,
                country: data.country,

                date_of_joining: data.date_of_joining || null,
                date_of_exit: data.date_of_exit || null,

                designation: data.designation,

                entity: data.entity || "MTINC",
            };

            // Explicitly remove project_uuid
            delete consultantData.project_uuid;
            delete consultantData.project_master_pid;

            addUpdateConsultant(consultantData).then((result: any) => {
                console.log(result);
                if (result) {
                    openSnackbar(result.error ? result.error.sqlMessage : "Consultant Saved.");
                } else openSnackbar("Some Error!");
            });
        }
    };
    return (
        <div className="space-y-6">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="px-4 py-5 bg-white shadow sm:rounded-lg sm:p-6">
                    <div className="md:grid md:grid-cols-3 md:gap-6">
                        <div className="md:col-span-1">
                            <h3 className="text-lg font-medium leading-6 text-gray-900">Personal Information</h3>
                            <p className="mt-1 text-xs text-gray-500">Legal Details</p>
                        </div>
                        <div className="mt-5 md:mt-0 md:col-span-2">
                            <div className="grid grid-cols-6 gap-6">
                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="emp-name" className="block text-sm font-medium text-gray-700">
                                        Name
                                    </label>
                                    <input {...register("name")} type="text" name="name" id="name" autoComplete="name" className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                                </div>

                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="last-name" className="block text-sm font-medium text-gray-700">
                                        Date of Birth
                                    </label>
                                    <input {...register("dob")} type="text" name="dob" id="dob" autoComplete="dob" className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                                    {/* <DatePicker {...register("dob")} dateFormat="yyyy-MM-dd" selected={props.profile.dob} onChange={(date) => {}} /> */}
                                    <span className="text-xs text-gray-400">yyyy-mm-dd</span>
                                </div>

                                {/* <div className="col-span-6 sm:col-span-4">
                                    <label htmlFor="email-address" className="block text-sm font-medium text-gray-700">
                                        Email address
                                    </label>
                                    <input type="text" disabled readOnly name="email-address" id="email-address" autoComplete="email" className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>

                <br />

                <div className="px-4 py-5 bg-white shadow sm:rounded-lg sm:p-6">
                    <div className="md:grid md:grid-cols-3 md:gap-6">
                        <div className="md:col-span-1">
                            <h3 className="text-lg font-medium leading-6 text-gray-900">Contact Information</h3>
                            <p className="mt-1 text-xs text-gray-500">Phone, Email etc.</p>
                        </div>
                        <div className="mt-5 md:mt-0 md:col-span-2">
                            <div className="grid grid-cols-6 gap-6">
                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
                                        Phone
                                    </label>
                                    <input {...register("phone", { required: false })} type="text" name="phone" id="phone" autoComplete="email" className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                        Email address
                                    </label>
                                    <input {...register("email", { required: true })} type="text" name="email" id="email" autoComplete="email" className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                                </div>{" "}
                            </div>
                        </div>
                    </div>
                </div>

                <br />

                <div className="px-4 py-5 bg-white shadow sm:rounded-lg sm:p-6">
                    <div className="md:grid md:grid-cols-3 md:gap-6">
                        <div className="md:col-span-1">
                            <h3 className="text-lg font-medium leading-6 text-gray-900">Legal Information</h3>
                            <p className="mt-1 text-xs text-gray-500">SSN etc.</p>
                        </div>
                        <div className="mt-5 md:mt-0 md:col-span-2">
                            <div className="grid grid-cols-6 gap-6">
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label htmlFor="masked_ssn" className="block text-sm font-medium text-gray-700">
                                        Social Security Number <small>(masked)</small>
                                    </label>
                                    <input {...register("masked_ssn", {})} type="text" name="masked_ssn" id="masked_ssn" autoComplete="masked_ssn" className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <br />

                <div className="px-4 py-5 bg-white shadow sm:rounded-lg sm:p-6">
                    <div className="md:grid md:grid-cols-3 md:gap-6">
                        <div className="md:col-span-1">
                            <h3 className="text-lg font-medium leading-6 text-gray-900">Permenant Address Information</h3>
                            <p className="mt-1 text-xs text-gray-500">Use a permanent address where you can receive mail.</p>
                        </div>
                        <div className="mt-5 md:mt-0 md:col-span-2">
                            <div className="grid grid-cols-6 gap-6">
                                <div className="col-span-6">
                                    <label htmlFor="street" className="block text-sm font-medium text-gray-700">
                                        Street address
                                    </label>
                                    <input {...register("street", {})} type="text" name="street" id="street" autoComplete="street-address" className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                                </div>

                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                    <label htmlFor="city" className="block text-sm font-medium text-gray-700">
                                        City
                                    </label>
                                    <input {...register("city", {})} type="text" name="city" id="city" autoComplete="city" className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                                </div>

                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                    <label htmlFor="region" className="block text-sm font-medium text-gray-700">
                                        State / Province
                                    </label>
                                    <input {...register("state", {})} type="text" name="state" id="state" autoComplete="state" className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                                </div>

                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                    <label htmlFor="postal-code" className="block text-sm font-medium text-gray-700">
                                        ZIP / Postal code
                                    </label>
                                    <input {...register("zip", {})} type="text" name="zip" id="zip" autoComplete="postal-code" className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                                </div>

                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="country" className="block text-sm font-medium text-gray-700">
                                        Country
                                    </label>
                                    <select {...register("country", {})} id="country" name="country" autoComplete="country-name" className="block w-full px-3 py-2 mt-1 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                        <option>United States</option>
                                        <option>Canada</option>
                                        <option>Mexico</option>
                                        <option>India</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <br />

                <div className="px-4 py-5 bg-white shadow sm:rounded-lg sm:p-6">
                    <div className="md:grid md:grid-cols-3 md:gap-6">
                        <div className="md:col-span-1">
                            <h3 className="text-lg font-medium leading-6 text-gray-900">Onboarding Information</h3>
                            <p className="mt-1 text-xs text-gray-500"></p>
                        </div>
                        <div className="mt-5 md:mt-0 md:col-span-2">
                            <div className="grid grid-cols-6 gap-6">
                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="last-name" className="block text-sm font-medium text-gray-700">
                                        Date Of Joining
                                    </label>
                                    <input {...register("date_of_joining")} type="text" name="date_of_joining" id="date_of_joining" autoComplete="date_of_joining" className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                                    {/* <DatePicker {...register("dob")} dateFormat="yyyy-MM-dd" selected={props.profile.dob} onChange={(date) => {}} /> */}
                                    <span className="text-xs text-gray-400">yyyy-mm-dd</span>
                                </div>

                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="last-name" className="block text-sm font-medium text-gray-700">
                                        Date Of Exit
                                    </label>
                                    <input {...register("date_of_exit")} type="text" name="date_of_exit" id="date_of_exit" autoComplete="date_of_exit" className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                                    {/* <DatePicker {...register("dob")} dateFormat="yyyy-MM-dd" selected={props.profile.dob} onChange={(date) => {}} /> */}
                                    <span className="text-xs text-gray-400">yyyy-mm-dd</span>
                                </div>

                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="last-name" className="block text-sm font-medium text-gray-700">
                                        Designation
                                    </label>
                                    <input {...register("designation")} type="text" name="designation" id="designation" autoComplete="designation" className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                                    {/* <DatePicker {...register("dob")} dateFormat="yyyy-MM-dd" selected={props.profile.dob} onChange={(date) => {}} /> */}
                                    <span className="text-xs text-gray-400"></span>
                                </div>

                                {/* <div className="col-span-6 sm:col-span-4">
                                    <label htmlFor="email-address" className="block text-sm font-medium text-gray-700">
                                        Email address
                                    </label>
                                    <input type="text" disabled readOnly name="email-address" id="email-address" autoComplete="email" className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>

                <br />


                <div className="px-4 py-5 bg-white shadow sm:rounded-lg sm:p-6">
                    <div className="md:grid md:grid-cols-3 md:gap-6">
                        <div className="md:col-span-1">
                            <h3 className="text-lg font-medium leading-6 text-gray-900">LCA Rate</h3>
                            <p className="mt-1 text-xs text-gray-500">Effective date and LCA rate</p>
                        </div>
                        <div className="mt-5 md:mt-0 md:col-span-2">
                            <div className="mb-4">
                                <h4 className="text-sm font-medium text-gray-700 mb-2">Existing Rates</h4>
                                {lcaRecords.length > 0 ? (
                                    <table className="min-w-full divide-y divide-gray-200">
                                        <thead className="bg-gray-50">
                                            <tr>
                                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Effective Date</th>
                                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Location 1</th>
                                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Rate 1</th>
                                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Location 2</th>
                                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Rate 2</th>
                                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Location 3</th>
                                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Rate 3</th>
                                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">
                                            {lcaRecords.map((record: any) => (
                                                <tr key={record.id}>
                                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900">
                                                        {record.effective_dt ? moment(record.effective_dt).format("YYYY-MM-DD") : "-"}
                                                    </td>
                                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900">
                                                        {record.location_1 || "-"}
                                                    </td>
                                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900">
                                                        {record.lca_rate_1 || 0}
                                                    </td>
                                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900">
                                                        {record.location_2 || "-"}
                                                    </td>
                                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900">
                                                        {record.lca_rate_2 || 0}
                                                    </td>
                                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900">
                                                        {record.location_3 || "-"}
                                                    </td>
                                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900">
                                                        {record.lca_rate_3 || 0}
                                                    </td>
                                                    <td className="px-3 py-2 whitespace-nowrap text-sm">
                                                        <button
                                                            type="button"
                                                            onClick={() => handleDeleteLca(record.id)}
                                                            className="text-red-600 hover:text-red-900"
                                                        >
                                                            Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <p className="text-sm text-gray-500">No LCA rates found. Add below.</p>
                                )}
                            </div>
                            <div className="grid grid-cols-6 gap-6">
                                <div className="col-span-6 sm:col-span-2">
                                    <label htmlFor="lca-date" className="block text-sm font-medium text-gray-700">
                                        Effective Date
                                    </label>
                                    <DatePicker
                                        id="lca-date"
                                        selected={newLcaDateObj}
                                        onChange={(date: any) => setNewLcaDateObj(date)}
                                        dateFormat="yyyy-MM-dd"
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        placeholderText="yyyy-mm-dd"
                                    />
                                </div>
                            </div>
                            <div className="grid grid-cols-6 gap-6 mt-4">
                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="lca-location1" className="block text-sm font-medium text-gray-700">
                                        Location 1
                                    </label>
                                    <input
                                        type="text"
                                        name="lca-location1"
                                        id="lca-location1"
                                        value={newLcaLocation1}
                                        onChange={(e) => setNewLcaLocation1(e.target.value)}
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    />
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="lca-rate1" className="block text-sm font-medium text-gray-700">
                                        LCA Rate 1
                                    </label>
                                    <input
                                        type="number"
                                        name="lca-rate1"
                                        id="lca-rate1"
                                        step="0.01"
                                        value={newLcaRate1}
                                        onChange={(e) => setNewLcaRate1(e.target.value)}
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    />
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="lca-location2" className="block text-sm font-medium text-gray-700">
                                        Location 2
                                    </label>
                                    <input
                                        type="text"
                                        name="lca-location2"
                                        id="lca-location2"
                                        value={newLcaLocation2}
                                        onChange={(e) => setNewLcaLocation2(e.target.value)}
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    />
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="lca-rate2" className="block text-sm font-medium text-gray-700">
                                        LCA Rate 2
                                    </label>
                                    <input
                                        type="number"
                                        name="lca-rate2"
                                        id="lca-rate2"
                                        step="0.01"
                                        value={newLcaRate2}
                                        onChange={(e) => setNewLcaRate2(e.target.value)}
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    />
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="lca-location3" className="block text-sm font-medium text-gray-700">
                                        Location 3
                                    </label>
                                    <input
                                        type="text"
                                        name="lca-location3"
                                        id="lca-location3"
                                        value={newLcaLocation3}
                                        onChange={(e) => setNewLcaLocation3(e.target.value)}
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    />
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="lca-rate3" className="block text-sm font-medium text-gray-700">
                                        LCA Rate 3
                                    </label>
                                    <input
                                        type="number"
                                        name="lca-rate3"
                                        id="lca-rate3"
                                        step="0.01"
                                        value={newLcaRate3}
                                        onChange={(e) => setNewLcaRate3(e.target.value)}
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    />
                                </div>
                            </div>
                            <div className="mt-4">
                                <button
                                    type="button"
                                    onClick={handleAddLca}
                                    className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                    Add LCA Rate
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="px-4 py-5 bg-white shadow sm:rounded-lg sm:p-6">
                <div className="md:grid md:grid-cols-3 md:gap-6">
                    <div className="md:col-span-1">
                        <h3 className="text-lg font-medium leading-6 text-gray-900">Notifications</h3>
                        <p className="mt-1 text-sm text-gray-500">Decide which communications you'd like to receive and how.</p>
                    </div>
                    <div className="mt-5 md:mt-0 md:col-span-2">
                        <form className="space-y-6" action="#" method="POST">
                            <fieldset>
                                <legend className="text-base font-medium text-gray-900">By Email</legend>
                                <div className="mt-4 space-y-4">
                                    <div className="flex items-start">
                                        <div className="flex items-center h-5">
                                            <input id="comments" name="comments" type="checkbox" className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500" />
                                        </div>
                                        <div className="ml-3 text-sm">
                                            <label htmlFor="comments" className="font-medium text-gray-700">
                                                Comments
                                            </label>
                                            <p className="text-gray-500">Get notified when someones posts a comment on a posting.</p>
                                        </div>
                                    </div>
                                    <div className="flex items-start">
                                        <div className="flex items-center h-5">
                                            <input id="candidates" name="candidates" type="checkbox" className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500" />
                                        </div>
                                        <div className="ml-3 text-sm">
                                            <label htmlFor="candidates" className="font-medium text-gray-700">
                                                Candidates
                                            </label>
                                            <p className="text-gray-500">Get notified when a candidate applies for a job.</p>
                                        </div>
                                    </div>
                                    <div className="flex items-start">
                                        <div className="flex items-center h-5">
                                            <input id="offers" name="offers" type="checkbox" className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500" />
                                        </div>
                                        <div className="ml-3 text-sm">
                                            <label htmlFor="offers" className="font-medium text-gray-700">
                                                Offers
                                            </label>
                                            <p className="text-gray-500">Get notified when a candidate accepts or rejects an offer.</p>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset>
                                <div>
                                    <legend className="text-base font-medium text-gray-900">Push Notifications</legend>
                                    <p className="text-sm text-gray-500">These are delivered via SMS to your mobile phone.</p>
                                </div>
                                <div className="mt-4 space-y-4">
                                    <div className="flex items-center">
                                        <input id="push-everything" name="push-notifications" type="radio" className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500" />
                                        <label htmlFor="push-everything" className="block ml-3 text-sm font-medium text-gray-700">
                                            Everything
                                        </label>
                                    </div>
                                    <div className="flex items-center">
                                        <input id="push-email" name="push-notifications" type="radio" className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500" />
                                        <label htmlFor="push-email" className="block ml-3 text-sm font-medium text-gray-700">
                                            Same as email
                                        </label>
                                    </div>
                                    <div className="flex items-center">
                                        <input id="push-nothing" name="push-notifications" type="radio" className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500" />
                                        <label htmlFor="push-nothing" className="block ml-3 text-sm font-medium text-gray-700">
                                            No push notifications
                                        </label>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div> */}

                <div className="flex justify-end pt-5 pb-10">
                    <Link to="/employees">
                        <button type="button" className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                            Cancel
                        </button>
                    </Link>

                    <button type="submit" className="inline-flex justify-center px-4 py-2 ml-3 text-sm font-medium text-white bg-blue-900 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        Save
                    </button>
                </div>
            </form>
            {/* <div className="pt-2 space-y-6">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="px-4 py-5 bg-white shadow sm:rounded-lg sm:p-6">
                    <div className="md:grid md:grid-cols-3 md:gap-6">
                        <div className="mt-5 md:mt-0 md:col-span-2">
                            <div className="grid grid-cols-12 gap-6">
                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="country" className="block text-sm text-gray-700 font-sm">
                                        Month-Year
                                    </label>
                                    <DatePicker dateFormat="MM/yyyy" showMonthYearPicker className="block w-full px-3 py-2 mt-1 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" selected={filters.checkDate} onChange={(date) => setFilters({ ...filters, checkDate: date })} />
                                </div>

                                <div className="pt-6">
                                    <button type="button" onClick={(e) => console.log()} className="px-4 py-2 text-sm font-medium text-white bg-blue-700 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-0 focus:ring-offset-0 hover:bg-blue-800 focus:ring-blue-300">
                                        Apply
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div> */}
        </div>
    );
}
